/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleSummaryModuleId } from './courseModuleSummaryModuleId';
import type { CourseModuleSummarySortIndex } from './courseModuleSummarySortIndex';
import type { CourseModuleSummaryAllowPartialSubmission } from './courseModuleSummaryAllowPartialSubmission';
import type { CourseModuleSummaryEcts } from './courseModuleSummaryEcts';
import type { CourseModuleSummaryLearningHours } from './courseModuleSummaryLearningHours';
import type { CourseModuleSummaryExamTaskIds } from './courseModuleSummaryExamTaskIds';
import type { CourseModuleSummarySegmentId } from './courseModuleSummarySegmentId';
import type { CourseModuleSummaryEnabledEventKinds } from './courseModuleSummaryEnabledEventKinds';
import type { CourseModuleSummaryMandates } from './courseModuleSummaryMandates';
import type { CourseModuleSummaryTitle } from './courseModuleSummaryTitle';
import type { CourseModuleSummaryAuthorName } from './courseModuleSummaryAuthorName';
import type { CourseModuleSummaryVersion } from './courseModuleSummaryVersion';
import type { CourseModuleSummaryState } from './courseModuleSummaryState';

/**
 * Summary view of a module within a course.
Combines module metadata (title, author, etc.) with course-specific settings.
 */
export interface CourseModuleSummary {
  moduleId?: CourseModuleSummaryModuleId;
  sortIndex?: CourseModuleSummarySortIndex;
  allowPartialSubmission?: CourseModuleSummaryAllowPartialSubmission;
  ects?: CourseModuleSummaryEcts;
  learningHours?: CourseModuleSummaryLearningHours;
  examTaskIds?: CourseModuleSummaryExamTaskIds;
  segmentId?: CourseModuleSummarySegmentId;
  enabledEventKinds?: CourseModuleSummaryEnabledEventKinds;
  mandates?: CourseModuleSummaryMandates;
  title?: CourseModuleSummaryTitle;
  authorName?: CourseModuleSummaryAuthorName;
  version?: CourseModuleSummaryVersion;
  state?: CourseModuleSummaryState;
}
